import { useLocation, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  // Extract app name from the first path segment after base URL
  const getAppName = () => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    if (pathSegments.length === 0) {
      return "App";
    }

    // Get the first segment and format it
    const firstSegment = pathSegments[0];

    // Split by dash, capitalize each word, and join with space
    const formattedName = firstSegment
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return formattedName;
  };

  const handleBackToHome = () => {
    navigate({ to: "/" });
  };

  return (
    <div className="aero:flex aero:min-h-screen aero:w-full aero:flex-col aero:items-center aero:justify-center aero:bg-white">
      <div className="aero:text-center">
        <h1 className="aero:text-[200px] aero:font-bold aero:leading-none aero:text-gray-200">
          404
        </h1>

        {/* Blue underline */}
        <div className="aero:mx-auto aero:mb-8 aero:h-1 aero:w-24 aero:bg-blue-600"></div>

        {/* App name and message */}
        <h2 className="aero:mb-2 aero:text-3xl aero:font-semibold aero:text-gray-900">
          {getAppName()} is under development
        </h2>
        <p className="aero:mb-8 aero:text-lg aero:text-gray-600">
          and will be coming soon.
        </p>

        {/* Back to Home button */}
        <Button
          intent="primary"
          design="solid"
          size="lg"
          onClick={handleBackToHome}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Home
        </Button>
      </div>
    </div>
  );
}
